<template>
    <div>
        <div class="d-flex align-center">
            <v-text-field
                    v-model="search"
                    class="datatable-search"
                    dense
                    hide-details
                    outlined
                    prepend-inner-icon="mdi-magnify"/>
            <div v-if="isAdmin" class="ml-4">
                <v-btn class="accent " fab icon rounded small
                       @click="openAddEditDialog = true">
                    <v-icon color="accentText">mdi-plus</v-icon>
                </v-btn>
            </div>
        </div>
        <v-data-table
                :headers="header"
                :items="items"
                :loading="loading"
                :search="search"
                class="rounded-lg shadow my-6">
            <template v-slot:[`item.actions`]="{ item }">
                <span class="data-table-actions-column">
                <TableAction v-if="isAdmin && !item.Default" :tooltip="$t('tooltips.editCircleName')" icon="mdi-pencil"
                             @click="editCircleName(item.CircleID, item.Name)"/>
                <TableAction :tooltip="$t('tooltips.members')" icon="mdi-account-multiple"
                             @click="edit(item.CircleID)"/>
                <router-link v-if="isAdmin" :to="{name: 'circleHistory', params: {id: item.CircleID}}">
                    <TableAction :tooltip="$t('tooltips.circleHistory')" icon="mdi-clipboard-text-clock"/>
                </router-link>
                <TableAction v-if="isAdmin" :tooltip="$t('tooltips.sendNotification')"
                             icon="mdi-bell-badge"
                             @click="sendNotificationToCircle(item.CircleID)"/>
                <TableAction v-if="isAdmin  && !item.Default" :tooltip="$t('tooltips.delete')" icon="mdi-delete"
                             @click="deleteItem(item.CircleID)"/>
                </span>
            </template>
        </v-data-table>
        <CircleAdd
                :circle-i-d="circleID"
                :circle-name="circleName"
                :open="openAddEditDialog"
                @close="closeAddEditDialog"
                @refreshTable="initItems"/>
        <DeleteDialog ref="deleteDialog"/>
    </div>
</template>

<script>
import CircleAdd from "@/components/Circles/CircleAdd";
import DeleteDialog from "@/components/reusable/Dialog/DeleteDialog";

export default {
  name: "MyCircles",
  components: {
    DeleteDialog, CircleAdd
  },
  created() {
    this.initItems();
  },
  mounted() {
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
  data() {
    return {
      search: '',
      loading: true,
      items: [],
      openAddEditDialog: false,
      openInviteDialog: false,
      loadingInvitation: false,
      validMail: false,
      emailInvitation: '',
      circleID: 0,
      circleName: ''
    };
  },
  computed: {
    header() {
      return [
        {text: this.$t('circles.circleName'), value: 'Name'},
        {text: this.$t('circles.owner'), value: 'Manager.FullName'},
        {text: '', value: 'actions', class: 'data-table-actions-column', cellClass: 'data-table-actions-column', sortable: false, width: 200, align: 'center'}
      ];
    },
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
  },
  methods: {
    initItems() {
      this.loading = true;
      const url = this.$store.getters.circles(this.organizationId);
      this.axios.get(url).then(({data}) => {
        this.items = data.Result;
      }).finally(() => {
        this.loading = false;
      });
    },
    edit(id) {
      this.$router.push({
        name: 'circleEdit', params: {
          id: id
        }
      });
    },
    deleteItem(circleID) {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.circle(circleID);
          this.$store.dispatch('setLoader', true);
          this.axios.delete(url).then(() => {
            this.initItems();
          }).finally(() => {
            this.$store.dispatch('setLoader', false);
          });
        }
      });
    },
    inviteUser() {
      this.openInviteDialog = true;
    },
    editCircleName(circleID, circleName) {
      this.circleID = circleID;
      this.circleName = circleName;
      this.openAddEditDialog = true;
    },
    closeAddEditDialog() {
      this.openAddEditDialog = false;
      this.circleID = 0;
      this.circleName = '';
    },
    sendNotificationToCircle(circleID) {
      this.$router.push({name: 'sendNotifications', params: {circleID}});
    },
    handleKeyup(e) {
      if (e.key === 'Escape') {
        this.$router.back();
      }
    }
  }
};
</script>

<style scoped>

</style>